import styled from 'styled-components';

const Hr = styled.div`
  border-top: 1px solid ${props => props.theme.dustGrey};
  margin: 20px 0 20px;
`;

export default Hr;
